import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';

export default function Topbar({ onToggleSidebar }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const doSearch = useCallback(async (q) => {
    if (q.length < 2) { setResults([]); setOpen(false); return; }
    try {
      const res = await API.get(`search/?q=${encodeURIComponent(q)}`);
      setResults(res.data);
      setOpen(true);
    } catch { setResults([]); }
  }, []);

  const handleChange = (e) => {
    const v = e.target.value;
    setQuery(v);
    doSearch(v);
  };

  const handleSelect = (r) => {
    setOpen(false);
    setQuery('');
    if (r.type === 'cours') navigate('/etudiant/cours');
    else if (r.type === 'evaluation') navigate('/etudiant/evaluations');
    else if (r.type === 'enseignant') navigate('/admin/users');
    else if (r.type === 'promotion') navigate('/admin/promotions');
  };

  const typeIcons = {
    cours: 'bi-book',
    evaluation: 'bi-clipboard-check',
    enseignant: 'bi-person',
    promotion: 'bi-mortarboard',
  };

  return (
    <header className="topbar">
      <div className="topbar-left">
        <button className="sidebar-toggle" onClick={onToggleSidebar}>
          <i className="bi bi-list" />
        </button>
      </div>
      <div className="topbar-right">
        <div className="topbar-search">
          <i className="bi bi-search search-icon" />
          <input
            type="text"
            placeholder="Rechercher..."
            value={query}
            onChange={handleChange}
            onBlur={() => setTimeout(() => setOpen(false), 200)}
            onFocus={() => query.length >= 2 && setOpen(true)}
          />
          {open && results.length > 0 && (
            <div className="search-dropdown">
              {results.map((r, i) => (
                <div key={i} className="search-result-item" onMouseDown={() => handleSelect(r)}>
                  <i className={`bi ${typeIcons[r.type] || 'bi-search'}`} style={{ color: 'var(--primary)', fontSize: 16 }} />
                  <div>
                    <div className="result-title">{r.titre}</div>
                    <div className="result-detail">{r.detail}</div>
                  </div>
                  <span className="result-type">{r.type}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
